import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon/snack-outline-blue.svg'
import _imports_1 from '@/assets/img/icon/user-outline-grey.svg'
import _imports_2 from '@/assets/img/icon/bus-front-outline-grey.svg'


const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "flex items-center gap-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Periode Waktu", -1)
const _hoisted_4 = { class: "mt-5" }
const _hoisted_5 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_6 = { class: "flex items-center justify-between px-5 py-3 border-grey-3" }
const _hoisted_7 = { class: "flex items-center gap-2" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "text-base font-bold" }
const _hoisted_10 = { class: "text-base font-bold text-grey" }
const _hoisted_11 = { class: "flex items-center gap-2" }
const _hoisted_12 = { class: "flex items-center gap-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "24"
}, null, -1)
const _hoisted_14 = { class: "text-lg font-bold text-primary" }
const _hoisted_15 = {
  key: 0,
  class: "pl-3 border-left-grey-3"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-white font-bold text-xs pi pi-check" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-bold text-xs" }, /*#__PURE__*/_toDisplayString('Terima Snack'), -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_20 = { class: "flex justify-between" }
const _hoisted_21 = { class: "flex items-center gap-2" }
const _hoisted_22 = { class: "text-base font-bold" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "flex items-center gap-4 mt-3" }
const _hoisted_25 = { class: "flex items-center gap-3" }
const _hoisted_26 = { class: "flex items-center gap-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-5",
  alt: "user"
}, null, -1)
const _hoisted_28 = { class: "text-grey text-sm font-medium" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", null, "|", -1)
const _hoisted_30 = { class: "flex items-center gap-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-5",
  alt: "bus"
}, null, -1)
const _hoisted_32 = { class: "text-grey text-sm font-medium" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", null, "|", -1)
const _hoisted_34 = { class: "flex items-center gap-2" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-5",
  alt: "user"
}, null, -1)
const _hoisted_36 = { class: "text-grey text-sm font-medium" }
const _hoisted_37 = { class: "text-right" }
const _hoisted_38 = {
  key: 0,
  class: "text-primary text-xs font-normal text-center border-primary py-1 px-2 rounded-md background-blue-4 w-max ml-auto"
}
const _hoisted_39 = { class: "text-base font-bold text-green mt-3" }
const _hoisted_40 = { class: "px-7 py-3 border-grey-3" }

import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import HjpConfirmationModal from '@/views/components/modal/HjpConfirmationModal.vue'
import Paginator from '@/views/components/paginator/Paginator.vue'
import moment from 'moment'
import Button from 'primevue/button'
import { onMounted, reactive, ref, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import Dropdown from 'primevue/dropdown'
import InputIconRight from '@/views/components/form/InputIconRight.vue'
import { checkProhibitedRoles } from '@/utils/helpers/checkProhibitedRole'
import MonthOptions from '../json/month'
import yearsOptions from '../json/year'


export default /*#__PURE__*/_defineComponent({
  __name: 'OpenedList',
  setup(__props) {

const endpoint = 'transaction/v2/TransactionPps'
const app = getCurrentInstance()
const {
  $toast, $strInd, $icon
} = app!.appContext.config.globalProperties
const icon = $icon
const router = useRouter()
const store = useStore()
const selectedIdHeader = ref(null) as any
const dataHeaderList = ref([]) as any
const dataDetailList = ref([]) as any
const monthOptions = ref(MonthOptions())
const yearOptions = ref(yearsOptions)
const currentMonth = moment().format('MM')
const currentYear = moment().year()
const selectedMonth = ref(monthOptions.value.find((item) => item.value === currentMonth))
const selectedYear = ref(yearOptions.value.find((item) => item.value === currentYear))
const inputSearch = ref()

const filters = ref({
  search: '',
  filterField: ['q'],
  pageNumber: 1,
  pageSize: 10,
  totalRecords: 0,
  custom: [['status', '=', 'CompletedNonCash'], ['startDate', '=', `${selectedYear.value?.value}-${selectedMonth.value?.value}-01`], ['endDate', '=', `${selectedYear.value?.value}-${selectedMonth.value?.value}-${moment().endOf('month').format('DD')}`]] as any
})

const filtersDetail = ref({
  search: '',
  filterField: ['q'],
  pageNumber: 1,
  pageSize: 10,
  totalRecords: 0,
  custom: [] as any
})

const attrModalConfirmation = reactive({
  show: false,
  title: 'Terima Snack?',
  subTitle: 'Pastikan snack yang diterima sesuai jumlahnya Stok yang sudah diterima tidak bisa diubah atau dikembalikan.',
  btnSubmitTitle: 'Terima Snack',
  btnBackTitle: 'Kembali',
  imgContent: require('@/assets/img/modal-confirmation/snack-confirmation.svg')
})

const openDetail = (id: any) => {
  dataDetailList.value = []
  if (id === selectedIdHeader.value) {
    selectedIdHeader.value = null
    filtersDetail.value.pageNumber = 1
    filtersDetail.value.search = ''
    filtersDetail.value.pageSize = 10
  } else {
    selectedIdHeader.value = id
    // eslint-disable-next-line no-use-before-define
    getDataHeaderDetail(id)
  }
}

const toDetailSnackPage = (data: any) => {
  const encId = encryptDecriptMethods.encrypt(data)
  router.push({
    name: 'approve-snack-detail',
    params: {
      id: encId
    }
  })
}

const getAllDataHeader = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${endpoint}/NonCash/Completed`, returnUrlPrams(filters.value)).then((response) => {
    // console.log('response', response)
    const { error, result, count } = response
    if (!error) {
      filters.value.totalRecords = count
      dataHeaderList.value = result
    }
  })
  store.dispatch('hideLoading')
}

const getDataHeaderDetail = async (id: string) => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${endpoint}/NonCash/Completed/${id}/TransactionPps`, returnUrlPrams(filtersDetail.value)).then((response) => {
    // console.log('resDetail', response)
    const { error, result, count } = response
    if (!error) {
      filtersDetail.value.totalRecords = count
      dataDetailList.value = result
    }
  })
  store.dispatch('hideLoading')
}

const onHeaderChangePage = (evt: any) => {
  filters.value.pageNumber = evt.page + 1
  // eslint-disable-next-line no-use-before-define
  getAllDataHeader()
}

const onDetailChangePage = (evt: any) => {
  filtersDetail.value.pageNumber = evt.page + 1
  // eslint-disable-next-line no-use-before-define
  getDataHeaderDetail(selectedIdHeader.value)
}

const hideDialogConfirmation = () => {
  attrModalConfirmation.show = false
  selectedIdHeader.value = null
}

const onSubmit = (id: string) => {
  // console.log('hehe', id)
  selectedIdHeader.value = id
  attrModalConfirmation.show = true
}

const printClosedStat = async (closedId: string) => {
  store.dispatch('showLoading')
  const payload = {}
  await apiUseCase.getBlob(`${endpoint}/NonCash/Completed/${closedId}/Export`).then((response) => {
    const { error, result } = response
    if (!error) {
      $toast.add({
        severity: 'success',
        detail: 'Data berhasil didownload',
        group: 'bc',
        closable: false,
        life: 3000
      })
      const blob = result
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `laporan Setoran Non-Tunai (${moment().format('DD MMMM YYYY')}).pdf`
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
      hideDialogConfirmation()
      getAllDataHeader()
    } else {
      $toast.add({
        severity: 'error',
        detail: 'Data gagal didownload',
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  })
  store.dispatch('hideLoading')
}

const onSubmitConfirmation = async () => {
  store.dispatch('showLoading')
  // console.log('submit')
  const payload = {
    status: 'CompletedSnack'
  }
  try {
    await apiUseCase.patchWithNoId(`${endpoint}/NonCash/Completed/${selectedIdHeader.value}/Status`, payload).then((response) => {
      // console.log('response', response)
      if (!response.error) {
        $toast.add({
          severity: 'success',
          // summary: msgHeader,
          detail: 'Berhasil menerima Snack',
          group: 'bc',
          closable: false,
          life: 3000
        })
        // hideDialogConfirmation()
        // getAllDataHeader()
        printClosedStat(selectedIdHeader.value)
      } else {
        $toast.add({
          severity: 'error',
          summary: 'Gagal menerima Snack',
          detail: response.message,
          group: 'bc',
          closable: false,
          life: 3000
        })
      }
    })
  } catch (error) {
    // console.log('err', error)
    $toast.add({
      severity: 'error',
      // summary: 'Gagal menerima Snack',
      detail: 'Gagal approve Snack. Silahkan hubungi Admin',
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
  store.dispatch('hideLoading')
}

const applyFilters = () => {
  // console.log('selectedMonth', selectedMonth)
  // console.log('selectedYear', selectedYear)
  const lastDate = moment(`${selectedYear.value?.value}-${selectedMonth.value?.value}`, 'YYYY-MM').endOf('month').format('DD')
  filters.value.custom = [['status', '=', 'CompletedNonCash'], ['startDate', '=', `${selectedYear.value?.value}-${selectedMonth.value?.value}-01`], ['endDate', '=', `${selectedYear.value?.value}-${selectedMonth.value?.value}-${lastDate}`]] as any
  filters.value.pageNumber = 1
  getAllDataHeader()
}

const onSearch = () => {
  filters.value.search = inputSearch.value
  filters.value.pageNumber = 1
  getAllDataHeader()
}

onMounted(() => {
  getAllDataHeader()
  // console.log('years', yearOptions.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", null, [
            _createVNode(_unref(Dropdown), {
              modelValue: selectedMonth.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedMonth).value = $event)),
              options: monthOptions.value,
              optionLabel: "name",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (applyFilters())),
              placeholder: "Pilih Bulan",
              class: "w-full md:w-14rem"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_unref(Dropdown), {
              modelValue: selectedYear.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedYear).value = $event)),
              options: yearOptions.value,
              optionLabel: "name",
              onChange: _cache[3] || (_cache[3] = ($event: any) => (applyFilters())),
              placeholder: "Pilih Tahun",
              class: "w-full md:w-14rem"
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(InputIconRight, {
            class: "input-search-header-custom",
            placeholder: "Cari Disini...",
            modelValue: inputSearch.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((inputSearch).value = $event)),
            canClick: true,
            icon: _unref($icon).svg.searchEva,
            onSubmitInput: onSearch,
            onKeyup: _withKeys(onSearch, ["enter"])
          }, null, 8, ["modelValue", "icon", "onKeyup"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_unref(dataHeaderList).length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Tidak Ada Data"))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(dataHeaderList), (data) => {
              return (_openBlock(), _createElementBlock("div", {
                key: data.Id
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["cursor-pointer", _unref(selectedIdHeader) === data.id ? 'pi pi-angle-down' : 'pi pi-angle-right']),
                      onClick: ($event: any) => (openDetail(data.Id))
                    }, null, 10, _hoisted_8),
                    _createElementVNode("div", _hoisted_9, [
                      _createTextVNode(_toDisplayString(data.PrintCode ?? '-') + " - " + _toDisplayString(_unref(moment)(data.CreatedAt).format('DD MMMM YYYY HH:mm')) + " ", 1),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(`(${data.TotalTransaction ?? 0} Stat)`), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("div", _hoisted_14, _toDisplayString(`Sisa: ${data.TransactionPpSnackSummary?.TotalSnackQuantityLeft ?? 0} Pack`), 1)
                    ]),
                    (_unref(checkProhibitedRoles)(['Setoran']))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createVNode(_unref(Button), {
                            class: "flex gap-2",
                            onClick: ($event: any) => (onSubmit(data.Id))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_16,
                              _hoisted_17
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_unref(selectedIdHeader) === data.Id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (_unref(dataDetailList).length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Tidak Ada Data"))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(dataDetailList), (dataDetail) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: dataDetail.Id,
                              class: "px-7 py-3 border-grey-3"
                            }, [
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("div", _hoisted_22, _toDisplayString(dataDetail.TrxId ?? '-'), 1),
                                    _createElementVNode("div", {
                                      class: "cursor-pointer text-xs text-primary",
                                      onClick: ($event: any) => (toDetailSnackPage({ dataHeader: data, dataDetail: dataDetail }))
                                    }, "Lihat Detail >", 8, _hoisted_23)
                                  ]),
                                  _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("div", _hoisted_25, [
                                      _createElementVNode("div", _hoisted_26, [
                                        _hoisted_27,
                                        _createElementVNode("div", _hoisted_28, _toDisplayString(`Kondektur: ${dataDetail.CondecturName ?? '-'}`), 1)
                                      ]),
                                      _hoisted_29,
                                      _createElementVNode("div", _hoisted_30, [
                                        _hoisted_31,
                                        _createElementVNode("div", _hoisted_32, _toDisplayString(`Nopol: ${dataDetail?.VehicleRegNumber ?? '-'}`), 1)
                                      ]),
                                      _hoisted_33,
                                      _createElementVNode("div", _hoisted_34, [
                                        _hoisted_35,
                                        _createElementVNode("div", _hoisted_36, _toDisplayString(`User Closing: ${dataDetail?.CompletedByFullName ?? '-'}`), 1)
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_37, [
                                  (dataDetail.HasNonCash)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, "Non Tunai"))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_39, _toDisplayString(`Sisa Snack: ${dataDetail.TotalSnackQuantityLeft ?? 0} Pack`), 1)
                                ])
                              ])
                            ]))
                          }), 128)),
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(Paginator, {
                          class: "trayek-pagination",
                          rows: filtersDetail.value.pageSize,
                          totalRecords: filtersDetail.value.totalRecords,
                          rowsPerPageOptions: [5, 10, 15, 20, 25],
                          onOnPage: onDetailChangePage
                        }, null, 8, ["rows", "totalRecords"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
      ]),
      _createElementVNode("div", null, [
        _createVNode(Paginator, {
          class: "trayek-pagination",
          rows: filters.value.pageSize,
          totalRecords: filters.value.totalRecords,
          rowsPerPageOptions: [5, 10, 15, 20, 25],
          onOnPage: onHeaderChangePage
        }, null, 8, ["rows", "totalRecords"])
      ])
    ]),
    _createVNode(HjpConfirmationModal, {
      show: attrModalConfirmation.show,
      imgContent: attrModalConfirmation.imgContent,
      title: attrModalConfirmation.title,
      subTitle: attrModalConfirmation.subTitle,
      btnSubmitTitle: attrModalConfirmation.btnSubmitTitle,
      btnBackTitle: attrModalConfirmation.btnBackTitle,
      onHideDialog: hideDialogConfirmation,
      onOnSubmit: onSubmitConfirmation
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle", "btnBackTitle"])
  ]))
}
}

})